import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isNumber, isString, isUnknownObject } from '~/shared/utils/guards'

function extractIds(value: unknown, key: string): number[] {
  return Array.isArray(value)
    ? value.map(item => (isUnknownObject(item) ? item[key] : null)).filter(isNumber)
    : []
}

function extractNames(value: unknown, key: string): string[] {
  return Array.isArray(value)
    ? value.map(item => (isUnknownObject(item) ? item[key] : null)).filter(isString)
    : []
}

export default class UnifiedProfileCareerGoal extends BaseModel {
  static override constructorName = 'UnifiedProfileCareerGoalModel'

  type: string = ''
  'career_direction_id': number[] = []
  'career_direction_names': string[] = []
  'internship_expectation_id': number[] = []
  'internship_expectation_names': string[] = []
  'internship_format_id': number | null = null
  'internship_format_name': string = ''
  'internship_timing_id': number[] = []
  'internship_timing_names': string[] = []
  'internship_priority_id': number[] = []
  'internship_priority_names': string[] = []
  'desired_position_id': number | null = null
  'desired_position': string = ''
  'employment_type_id': number | null = null
  'employment_type': string = ''
  'employment_format_id': number | null = null
  'employment_format': string = ''
  'work_type_id': number | null = null
  'work_type': string = ''
  salary: number | null = null
  'internship_start_date': string | null = null
  'internship_end_date': string | null = null
  'internship_comment': string | null = null

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.career_direction_id = extractIds(data.career_direction, 'career_direction_id')
      this.career_direction_names = extractNames(data.career_direction, 'career_direction')
      this.internship_expectation_id = extractIds(
        data.internship_expectation,
        'internship_expectation_id'
      )
      this.internship_expectation_names = extractNames(
        data.internship_expectation,
        'internship_expectation'
      )
      this.internship_timing_id = extractIds(data.internship_timing, 'internship_timing_id')
      this.internship_timing_names = extractNames(data.internship_timing, 'internship_timing')
      this.internship_priority_id = extractIds(data.internship_priority, 'internship_priority_id')
      this.internship_priority_names = extractNames(
        data.internship_priority,
        'internship_priority'
      )

      const format = data.internship_format
      if (isUnknownObject(format)) {
        this.internship_format_id = isNumber(format.internship_format_id)
          ? format.internship_format_id
          : null
        this.internship_format_name = isString(format.internship_format)
          ? format.internship_format
          : ''
      }
    }
  }
}

registerModel(UnifiedProfileCareerGoal)
